import SelectBanks from "./SelectBanks";
import SignDirectDebit from "./SignDirectDebit";

const DirectDebitPages = {
	SelectBanks,
	SignDirectDebit,
}

export default DirectDebitPages;